import { useState } from 'react'
import { AccountRecord, useUpdateAccountMutation } from '../../api/client'
import { AutoAction, getAutoActions } from './autoActions'
import DescriptiveToggle from './DescriptiveToggle'

const AutoHideSevereContentToggle = ({ account }: { account: AccountRecord }) => {
    const [updateAccountMutation, { loading }] = useUpdateAccountMutation()
    const [enabled, setEnabled] = useState(account.autoHideSevereContent)

    const onToggle = async (isEnabled: boolean) => {
        setEnabled(isEnabled)
        await updateAccountMutation({
            variables: {
                id: Number(account.id),
                autoHideSevereContent: !enabled
            }
        })
    }

    const disabled =
        getAutoActions(account.socialMediaServiceDisplayName || '').includes(AutoAction.Hide) ===
        false

    return (
        <DescriptiveToggle
            id="AutoHideSevere"
            disabled={disabled}
            checked={enabled}
            onToggle={onToggle}
            label="Auto-hide (most popular)"
            loading={loading}
            subtitle="Hides the comment from public view. The commenter is not notified. Can be reversed."
            tooltip={disabled ? `Not supported by this social network` : ``}
        />
    )
}

export default AutoHideSevereContentToggle
